/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1Report } from '../models/V1Report';
import { HttpFile } from '../http/http';

/**
* ListReportsResponse carries the page of reports and pagination state.
*/
export class V1ListReportsResponse {
    /**
    * The reports in this page.
    */
    'reports'?: Array<V1Report>;
    /**
    * Total reports available across all pages, for the filter applied.
    */
    'totalSize'?: number;
    /**
    * Token to pass as page_token on the next call. Empty when the last page has been returned.
    */
    'nextPageToken'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "reports",
            "baseName": "reports",
            "type": "Array<V1Report>",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ListReportsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

